import { render } from "./PermissionForm.vue?vue&type=template&id=1e8c2142"
import script from "./PermissionForm.vue?vue&type=script&lang=js"
export * from "./PermissionForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__